import { SmileySticker, ThumbsUp, Star } from '@phosphor-icons/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const AnalyticsBlock = ({ subtitle, title, faces = 0, thumbs = 0, stars = 0 }) => {
  const { t } = useTranslation(['surveys'])
  return (
    <div className="ctp-survey__analytics-col">
      <div className="ctp-survey__analytics-subtitle">{subtitle}</div>
      <div className="ctp-survey__analytics-title">{title}</div>
      <div className="ctp-survey__analytics-text">
        <SmileySticker size={16} /> {t('surveys:analytics.smileyFaces')}
        <div className="ctp-survey__analytics-subtitle">{faces}</div>
      </div>
      <div className="ctp-survey__analytics-text">
        <ThumbsUp size={16} />
        {t('surveys:analytics.thumbsUpDown')}{' '}
        <div className="ctp-survey__analytics-subtitle">{thumbs}</div>
      </div>
      <div className="ctp-survey__analytics-text">
        <Star size={16} /> {t('surveys:analytics.starScale')}
        <div className="ctp-survey__analytics-subtitle">{stars}</div>
      </div>
    </div>
  )
}

AnalyticsBlock.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  faces: PropTypes.number,
  thumbs: PropTypes.number,
  stars: PropTypes.number,
}

export default AnalyticsBlock
